/* ============================================================
   F.G. EDWARDS - Journees poules PDP : flock behaviour
   Powers two sections that both load this file (defer):
     - jp-flock-builder ("Votre panier d'oeufs"): 12-cup egg carton
       filled from the real cart + stepper preview, eggs/semaine
       estimate, batch add of every stepper quantity in one
       /cart/add.js items[] call, mini carton chip docked into the
       sticky bar.
     - jp-breed-comparison (rail): per-card quick-add of qty 1.
   Both resolve each breed's variant against the visitor's stored
   {store, date} (localStorage jp-event-selection, written by
   jp-pdp.js) and reuse the jp-pdp.js cart-drawer re-render pattern.
   A window guard makes the double <script> (one per section) a no-op
   on the second load. Shared helpers are exported on window for the
   comparison rail. GA4 is guarded: jp_flock_view, jp_flock_add.
   ============================================================ */
(function () {
  'use strict';
  if (window.__jpFlockLoaded) return;
  window.__jpFlockLoaded = true;

  var STORAGE_KEY = 'jp-event-selection';

  function ga(name, params) {
    if (typeof window.gtag === 'function') {
      try { window.gtag('event', name, params || {}); } catch (e) { /* noop */ }
    }
  }

  function shopRoot() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  }

  function parseJSON(el) {
    if (!el) return null;
    try { return JSON.parse(el.textContent || ''); } catch (e) { return null; }
  }

  function getSelection() {
    try {
      var s = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
      if (s && s.store) return s;
    } catch (e) { /* noop */ }
    return null;
  }

  function resolveVariant(variants, sel) {
    if (!sel || !variants) return null;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (v && v.available && v.option1 === sel.store && v.option2 === sel.date) return v;
    }
    return null;
  }

  function makeMoneyFormatter(format) {
    format = (format || '${{amount}}')
      .replace(/&quot;/g, '"').replace(/&#123;/g, '{').replace(/&#125;/g, '}').replace(/&amp;/g, '&');
    return function (cents) {
      if (typeof cents !== 'number' || isNaN(cents)) cents = 0;
      var dollars = (cents / 100).toFixed(2);
      var noDec = Math.round(cents / 100).toString();
      return format
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, dollars.replace('.', ','))
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDec.replace(/\B(?=(\d{3})+(?!\d))/g, ','))
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDec)
        .replace(/\{\{\s*amount_with_space_separator\s*\}\}/g, dollars.replace(/\B(?=(\d{3})+(?!\d))/g, ' '))
        .replace(/\{\{\s*amount\s*\}\}/g, dollars);
    };
  }

  /* ---------- shared: batch add with cart-drawer re-render ---------- */
  function addItems(items) {
    return new Promise(function (resolve, reject) {
      if (!items || !items.length) { reject(new Error('empty')); return; }
      var body = { items: items };
      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
        body.sections = cartDrawer.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
        if (typeof cartDrawer.setActiveElement === 'function') cartDrawer.setActiveElement(document.activeElement);
      }
      var controller = new AbortController();
      var timeout = setTimeout(function () { controller.abort(); }, 8000);
      var addUrl = (window.routes && window.routes.cart_add_url) || (shopRoot() + 'cart/add.js');

      fetch(addUrl, {
        method: 'POST',
        signal: controller.signal,
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      })
        .then(function (r) {
          clearTimeout(timeout);
          return r.json().then(function (data) { return { ok: r.ok, data: data }; });
        })
        .then(function (res) {
          if (!res.ok || (res.data && res.data.status && res.data.status !== 200)) {
            throw new Error((res.data && (res.data.description || res.data.message)) || 'Erreur');
          }
          if (typeof window.publish === 'function' && typeof window.PUB_SUB_EVENTS !== 'undefined') {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'jp-flock' });
          }
          if (cartDrawer) {
            if (cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
            if (typeof cartDrawer.renderContents === 'function') cartDrawer.renderContents(res.data);
          }
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('jp-flock:cart-changed'));
          resolve(res.data);
        })
        .catch(function (err) {
          clearTimeout(timeout);
          reject(err && err.name === 'AbortError' ? new Error('timeout') : err);
        });
    });
  }

  /* export for the comparison rail (and anything else on the page) */
  window.jpFlockAddItems = addItems;
  window.jpFlockGetSelection = getSelection;
  window.jpFlockResolveVariant = resolveVariant;

  /* ---------- shared scroll-to-buy-box ---------- */
  function scrollToAtc() {
    var target = document.querySelector('[data-jp-atc]') || document.querySelector('[data-jp-buybox]');
    if (target && target.scrollIntoView) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  /* re-resolve helper: fire cb shortly after a buy-box store/date change */
  function onSelectionChange(cb) {
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('[data-jp-date], [data-jp-store]')) {
        setTimeout(cb, 60);
      }
    });
    window.addEventListener('storage', function (e) { if (e.key === STORAGE_KEY) cb(); });
  }

  /* ---------- flock builder ---------- */
  function initFlockBuilder() {
    var root = document.querySelector('[data-jp-flock]');
    if (!root) return;

    var money = makeMoneyFormatter(root.getAttribute('data-money-format'));
    var unavailableTmpl = root.getAttribute('data-unavailable-tmpl') || 'Non disponible le {date}';
    var estimateTmpl = root.getAttribute('data-estimate-tmpl') || '≈ {n} oeufs par semaine';
    var birdMap = parseJSON(root.querySelector('[data-jp-bird-map]')) || {};

    var cups = [].slice.call(root.querySelectorAll('[data-jp-cup]'));
    var estimateEl = root.querySelector('[data-jp-estimate]');
    var hintEl = root.querySelector('[data-jp-hint]');
    var addBtn = root.querySelector('[data-jp-flock-add]');
    var addText = root.querySelector('[data-jp-flock-add-text]');
    var msgEl = root.querySelector('[data-jp-flock-msg]');
    var baseLabel = (addBtn && addBtn.getAttribute('data-base-label')) || 'Ajouter au troupeau';

    var rows = [].slice.call(root.querySelectorAll('[data-jp-flock-row]')).map(function (el) {
      return {
        el: el,
        hex: el.getAttribute('data-hex') || '',
        eggs: parseInt(el.getAttribute('data-eggs'), 10) || 0,
        variants: parseJSON(el.querySelector('[data-jp-row-variants]')) || [],
        qty: 0,
        variant: null,
        minus: el.querySelector('[data-jp-step="-1"]'),
        plus: el.querySelector('[data-jp-step="1"]'),
        val: el.querySelector('[data-jp-step-val]'),
        note: el.querySelector('[data-jp-row-note]')
      };
    });

    var cartEggs = [];

    var chip = null;
    function ensureChip() {
      if (chip !== null) return chip;
      var sticky = document.querySelector('[data-jp-sticky]');
      if (!sticky) { chip = false; return chip; }
      chip = document.createElement('span');
      chip.className = 'jpp-flock__chip';
      chip.setAttribute('data-jp-flock-chip', '');
      chip.hidden = true;
      chip.innerHTML = '<span class="jpp-flock__chip-dot" aria-hidden="true"></span><b data-jp-flock-chip-n>0</b>';
      sticky.insertBefore(chip, sticky.firstChild);
      return chip;
    }
    function updateChip(total) {
      var c = ensureChip();
      if (!c) return;
      var n = c.querySelector('[data-jp-flock-chip-n]');
      if (n) n.textContent = total;
      c.hidden = total <= 0;
    }

    function render() {
      var eggs = [];
      cartEggs.forEach(function (e) { eggs.push(e); });
      rows.forEach(function (r) {
        for (var i = 0; i < r.qty; i++) eggs.push({ hex: r.hex, eggs: r.eggs, preview: true });
      });
      var total = eggs.length;

      cups.forEach(function (cup, i) {
        cup.className = 'jpp-flock__cup';
        cup.textContent = '';
        cup.style.removeProperty('--cup');
        if (total > 12 && i === 11) {
          cup.classList.add('jpp-flock__cup--more');
          cup.textContent = '+' + (total - 11);
        } else if (i < total) {
          var e = eggs[i];
          cup.classList.add('is-filled');
          if (e.preview) cup.classList.add('is-preview');
          if (e.hex) cup.style.setProperty('--cup', e.hex);
        }
      });

      var yearSum = 0;
      eggs.forEach(function (e) { yearSum += (e.eggs || 0); });
      var perWeek = Math.round(yearSum / 52);
      if (estimateEl) {
        if (perWeek > 0) { estimateEl.textContent = estimateTmpl.replace('{n}', perWeek); estimateEl.hidden = false; }
        else { estimateEl.hidden = true; }
      }

      var sumCents = 0, qtyTotal = 0;
      rows.forEach(function (r) { if (r.qty > 0 && r.variant) { sumCents += r.variant.price * r.qty; qtyTotal += r.qty; } });
      if (addText) addText.textContent = qtyTotal > 0 ? (baseLabel + ' · ' + money(sumCents)) : baseLabel;
      if (addBtn && !addBtn.classList.contains('is-loading')) addBtn.disabled = qtyTotal <= 0;

      updateChip(total);
    }

    function resolveRows() {
      var selection = getSelection();
      rows.forEach(function (r) {
        r.variant = selection ? resolveVariant(r.variants, selection) : null;
        var unavailable = selection && !r.variant;
        if (unavailable) {
          r.qty = 0;
          if (r.val) r.val.textContent = '0';
          if (r.plus) r.plus.disabled = true;
          if (r.minus) r.minus.disabled = true;
          r.el.classList.add('is-unavailable');
          if (r.note) { r.note.textContent = unavailableTmpl.replace('{date}', selection.date || ''); r.note.hidden = false; }
        } else {
          if (r.plus) r.plus.disabled = false;
          if (r.minus) r.minus.disabled = r.qty <= 0;
          r.el.classList.remove('is-unavailable');
          if (r.note) r.note.hidden = true;
        }
      });
      if (hintEl) hintEl.hidden = !!selection;
      render();
    }

    function flashHint() {
      if (!hintEl) return;
      hintEl.hidden = false;
      hintEl.classList.add('is-flash');
      setTimeout(function () { hintEl.classList.remove('is-flash'); }, 1200);
    }

    function loadCart() {
      fetch(shopRoot() + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          cartEggs = [];
          var items = (cart && cart.items) || [];
          items.forEach(function (li) {
            var info = birdMap[String(li.product_id)];
            if (!info) return;
            for (var i = 0; i < li.quantity; i++) cartEggs.push({ hex: info.hex, eggs: info.eggs });
          });
          render();
        })
        .catch(function () { /* noop */ });
    }

    function showMsg(text) {
      if (!msgEl) return;
      msgEl.textContent = text;
      msgEl.classList.add('is-visible');
      setTimeout(function () { msgEl.classList.remove('is-visible'); }, 5000);
    }

    /* steppers */
    rows.forEach(function (r) {
      if (r.plus) r.plus.addEventListener('click', function () {
        var selection = getSelection();
        if (!selection) { scrollToAtc(); flashHint(); return; }
        r.variant = resolveVariant(r.variants, selection);
        if (!r.variant) { resolveRows(); return; }
        var cap = (r.variant.inventory_quantity && r.variant.inventory_quantity > 0) ? r.variant.inventory_quantity : 99;
        if (r.qty < cap) r.qty++;
        if (r.val) r.val.textContent = r.qty;
        if (r.minus) r.minus.disabled = r.qty <= 0;
        render();
      });
      if (r.minus) r.minus.addEventListener('click', function () {
        if (r.qty > 0) r.qty--;
        if (r.val) r.val.textContent = r.qty;
        if (r.minus) r.minus.disabled = r.qty <= 0;
        render();
      });
    });

    /* batch add */
    if (addBtn) addBtn.addEventListener('click', function () {
      var selection = getSelection();
      if (!selection) { scrollToAtc(); flashHint(); return; }
      var items = [], breeds = 0, qtyTotal = 0;
      rows.forEach(function (r) {
        if (r.qty > 0 && r.variant) { items.push({ id: parseInt(r.variant.id, 10), quantity: r.qty }); breeds++; qtyTotal += r.qty; }
      });
      if (!items.length) return;
      addBtn.classList.add('is-loading');
      addBtn.disabled = true;
      addItems(items).then(function () {
        addBtn.classList.remove('is-loading');
        ga('jp_flock_add', { breeds: breeds, total_qty: qtyTotal });
        rows.forEach(function (r) { r.qty = 0; if (r.val) r.val.textContent = '0'; if (r.minus) r.minus.disabled = true; });
        loadCart();
      }).catch(function () {
        addBtn.classList.remove('is-loading');
        addBtn.disabled = false;
        showMsg('Erreur, veuillez réessayer.');
      });
    });

    /* GA4 view (once) */
    if ('IntersectionObserver' in window) {
      var seen = false;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !seen) { seen = true; ga('jp_flock_view', {}); io.disconnect(); }
        });
      }, { threshold: 0.2 });
      io.observe(root);
    }

    document.addEventListener('jp-flock:cart-changed', loadCart);
    onSelectionChange(resolveRows);

    resolveRows();
    loadCart();
  }

  /* ---------- comparison rail ---------- */
  function initComparisonRail() {
    var rail = document.querySelector('[data-jp-rail]');
    if (!rail) return;
    var unavailableTmpl = rail.getAttribute('data-unavailable-tmpl') || 'Non disponible le {date}';

    var cta = rail.querySelector('[data-jp-rail-cta]');
    if (cta) cta.addEventListener('click', function () { scrollToAtc(); });

    var cards = [].slice.call(rail.querySelectorAll('[data-jp-rail-card]'));
    cards.forEach(function (card) {
      var addBtn = card.querySelector('[data-jp-rail-add]');
      if (!addBtn) return;
      var variants = parseJSON(card.querySelector('[data-jp-rail-variants]')) || [];
      var note = card.querySelector('[data-jp-rail-note]');
      var defaultLabel = addBtn.textContent;

      function refresh() {
        var sel = getSelection();
        if (!sel) { addBtn.disabled = false; card.classList.remove('is-unavailable'); if (note) note.hidden = true; return; }
        var v = resolveVariant(variants, sel);
        if (v) {
          addBtn.disabled = false; card.classList.remove('is-unavailable'); if (note) note.hidden = true;
        } else {
          addBtn.disabled = true; card.classList.add('is-unavailable');
          if (note) { note.textContent = unavailableTmpl.replace('{date}', sel.date || ''); note.hidden = false; }
        }
      }

      addBtn.addEventListener('click', function () {
        var sel = getSelection();
        if (!sel) { scrollToAtc(); return; }
        var v = resolveVariant(variants, sel);
        if (!v) { refresh(); return; }
        addBtn.disabled = true;
        addBtn.classList.add('is-loading');
        addItems([{ id: parseInt(v.id, 10), quantity: 1 }]).then(function () {
          addBtn.classList.remove('is-loading');
          addBtn.classList.add('is-added');
          addBtn.textContent = 'Ajouté';
          ga('jp_flock_add', { breeds: 1, total_qty: 1, source: 'comparison' });
          setTimeout(function () {
            addBtn.classList.remove('is-added');
            addBtn.textContent = defaultLabel;
            addBtn.disabled = false;
          }, 1800);
        }).catch(function () {
          addBtn.classList.remove('is-loading');
          addBtn.disabled = false;
        });
      });

      refresh();
      onSelectionChange(refresh);
    });
  }

  function boot() {
    initFlockBuilder();
    initComparisonRail();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
